import axios from "axios";
import qs from "qs";
// import api from "../sharedInterceptors";

// api.defaults.baseURL = process.env.REACT_APP_MAPPER_DISPLAY_BASEURL_V1;
class historicFiresAPI {
   async getAllHistoricFiresApi({
    country,
    departments,
    pageSize = 10000,
    startIndex = 0,
  }) {
    return await axios.post(
      `${process.env.REACT_APP_MAPPER_DISPLAY_BASEURL_V1}/historicfire/get_all/`,
      {
        country,                 
        department: departments, 
        // pageSize,
        // startIndex,
      },
    );
  }
async getHistoricFirePolygonsApi({ ids }) {
  return await axios.post(
    `${process.env.REACT_APP_MAPPER_DISPLAY_BASEURL_V1}/historicfire/get_polygons/`,
    { ids },
  );
}
  // async getHistoricFiresByDateApi(startDate, endDate, country, departments) {
  //   const params = {};

  //   if (startDate) params.date_from = startDate;
  //   if (endDate) params.date_to = endDate;
  //   if (country) params.country = country;
  //   if (Array.isArray(departments) && departments.length > 0) {
  //     params.department = departments;
  //   }

  //   return await api.get(
  //     `${process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1}/historicfire/get_by_filter/`,
  //     {
  //       params,
  //       paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
  //     },
  //   );
  // }
  // async getHistoricFiresByIdsApi(ids) {
  //   return await api.get(
  //     `${process.env.REACT_APP_MAPPER_HISTORIC_BASEURL_V1}/historicfire/get_polygons/`,
  //     {
  //       params: {
  //         ids,
  //       },
  //       paramsSerializer: (params) => {
  //         return qs.stringify(params, { arrayFormat: "repeat" });
  //       },
  //     },
  //   );
  // }
}

export default historicFiresAPI;
